module.exports = __webpack_public_path__ + "media/application/images/ui/deal-how-to-online-shopping-8443b2cfe96906da75e388254fc8dcca.png";